import CustomTabs from "../../../components/CustomTabs/CustomTabs.js";
import Tasks from "../../../components/Tasks/Tasks.js";
import GridItem from "../../../components/Grid/GridItem.js";
import DateRangeIcon from '@material-ui/icons/DateRange';
import MDBox from "components/MDBox";
import CircularProgress from '@mui/material/CircularProgress';

import { useTranslation } from "react-i18next";
function StoreReportProducts(props) {

  const { t }        = useTranslation();
 
  let productReportDataToday   = [];
  let productReportDataWeek    = [];
  let productReportDataMonth   = [];
  let productReportDataYear    = [];
  let productReportDataAllTime = [];

  let productsObjectToday      = props.productsObjectToday;
  let productsObjectWeek       = props.productsObjectWeek;
  let productsObjectMonth      = props.productsObjectMonth;
  let productsObjectYear       = props.productsObjectYear;
  let productsObjectAllTime    = props.productsObjectAllTime;
  let isProductsLoading        = props.isProductsLoading;
  let tabOnClick              = props.tabOnClick;

  if(Object.keys(productsObjectToday).length > 0)
  {
    productReportDataToday = [    
      t("Total Products")+' : '+productsObjectToday.totalProductsCount,
      t("Approved Products")+' : '+productsObjectToday.totalApprovedProductsCount,
      t("Disabled Products")+' : '+productsObjectToday.totalDisabledProductsCount,
      t("Pending Products")+' : '+productsObjectToday.totalPendingProductsCount,
    ];  
  }

  if(Object.keys(productsObjectWeek).length > 0)
  {
    productReportDataWeek = [    
      t("Total Products")+' : '+productsObjectWeek.totalProductsCount,
      t("Approved Products")+' : '+productsObjectWeek.totalApprovedProductsCount,
      t("Disabled Products")+' : '+productsObjectWeek.totalDisabledProductsCount,
      t("Pending Products")+' : '+productsObjectWeek.totalPendingProductsCount,
    ];  
  }

  if(Object.keys(productsObjectMonth).length > 0)
  {
    productReportDataMonth = [    
      t("Total Products")+' : '+productsObjectMonth.totalProductsCount,
      t("Approved Products")+' : '+productsObjectMonth.totalApprovedProductsCount,
      t("Disabled Products")+' : '+productsObjectMonth.totalDisabledProductsCount,
      t("Pending Products")+' : '+productsObjectMonth.totalPendingProductsCount,
    ];  
  }

  if(Object.keys(productsObjectYear).length > 0)
  {
    productReportDataYear = [    
      t("Total Products")+' : '+productsObjectYear.totalProductsCount,
      t("Approved Products")+' : '+productsObjectYear.totalApprovedProductsCount,
      t("Disabled Products")+' : '+productsObjectYear.totalDisabledProductsCount,
      t("Pending Products")+' : '+productsObjectYear.totalPendingProductsCount,
    ];  
  }  

  if(Object.keys(productsObjectAllTime).length > 0)
  {
    productReportDataAllTime = [    
      t("Total Products")+' : '+productsObjectAllTime.totalProductsCount,
      t("Approved Products")+' : '+productsObjectAllTime.totalApprovedProductsCount,
      t("Disabled Products")+' : '+productsObjectAllTime.totalDisabledProductsCount,
      t("Pending Products")+' : '+productsObjectAllTime.totalPendingProductsCount,
    ];  
  }  

  return (
    (
      productReportDataToday.length > 0 || 
      productReportDataWeek.length > 0 || 
      productReportDataMonth.length > 0 || 
      productReportDataYear.length > 0 || 
      productReportDataAllTime.length > 0       
    ) ? 
      <GridItem xs={12} sm={6} className="rowTableCell">

      {isProductsLoading ?       
        <MDBox py={3} sx={{ textAlign: "center", position: "absolute", top: 75, zIndex: 100, width: "100%" }}>   
          <CircularProgress size={30} style={{color: '#1a90ff', margin: '0px auto'}}/>
        </MDBox>
      : null}       

      <CustomTabs
        title={t("Store Statistics Products")+" : "}
        headerColor="rose"
        tabOnClick={tabOnClick}
        tabs={[
          {
            tabName: "Today",
            tabValue: "today",
            tabSection: "products",            
            tabIcon: DateRangeIcon,
            tabContent: (
              <Tasks
                tasksIndexes={[0, 1, 2, 3]}
                tasks={productReportDataToday}
              />
            ),
          },
          {
            tabName: "This Week",
            tabValue: "week",
            tabSection: "products",            
            tabIcon: DateRangeIcon,
            tabContent: (
              <Tasks
                tasksIndexes={[0, 1, 2, 3]}
                tasks={productReportDataWeek}
              />
            ),
          },
          {
            tabName: "This Month",
            tabValue: "month",
            tabSection: "products",             
            tabIcon: DateRangeIcon,
            tabContent: (
              <Tasks
                tasksIndexes={[0, 1, 2, 3]}
                tasks={productReportDataMonth}
              />
            ),
          },
          {
            tabName: "This Year",
            tabValue: "year",
            tabSection: "products",             
            tabIcon: DateRangeIcon,
            tabContent: (
              <Tasks
                tasksIndexes={[0, 1, 2, 3]}
                tasks={productReportDataYear}
              />
            ),
          },
          {
            tabName: "All Time",
            tabValue: "all-time",
            tabSection: "products",             
            tabIcon: DateRangeIcon,
            tabContent: (
              <Tasks
                tasksIndexes={[0, 1, 2, 3]}
                tasks={productReportDataAllTime}
              />
            ),
          },
        ]}
      />
      </GridItem>
    : <></>
  )
}

export default StoreReportProducts;